'use client'

import { createContext, useContext } from 'react'
import type { ReactElement, ReactNode } from 'react'
import type { DeviceType } from 'utils/deviceTypeFromUserAgent'

export type { DeviceType }

const DeviceContext = createContext<DeviceType>('desktop')

export const useDevice = (): DeviceType => useContext(DeviceContext)

type DeviceProviderProps = {
  deviceType: DeviceType
  children: ReactNode
}

export const DeviceProvider = ({
  deviceType,
  children,
}: DeviceProviderProps): ReactElement => (
  <DeviceContext.Provider value={deviceType}>{children}</DeviceContext.Provider>
)
